import { FormattedMessage } from 'react-intl';

import { createColumnDefinitionBuilder } from 'ui-components/components/react-table-wrapper/create-column-definition-builder';
import { Text, TextType } from 'ui-components/components/text';

import { tableMessages } from '../../messages';

const NameCell = ({ value }: { value: string }) => {
  return <Text textType={TextType.Paragraph} value={value} />;
};

export const createNameColumnDefinition = createColumnDefinitionBuilder({
  accessor: 'name',
  Header: <FormattedMessage {...tableMessages.headers.name} />,
  Cell: NameCell,
  width: 3,
  minWidth: 200,
});
